/**
 * Standard: first letter uppercase so tags display consistently (e.g. "robot" -> "Robot").
 */
export function capitalizeFirstLetter(str: string): string {
  if (!str || typeof str !== 'string') return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Normalize a single tag: trim and capitalize first letter.
 */
export function normalizeTag(tag: string): string {
  if (!tag || typeof tag !== 'string') return '';
  return capitalizeFirstLetter(tag.trim());
}

/**
 * Normalize tags string: split by #, trim, capitalize first letter, remove empty, deduplicate, join with #.
 */
export function normalizeTagsString(input: string | undefined | null): string {
  if (input == null || typeof input !== 'string') return '';
  return tagsStringToArray(input).join('#');
}

/**
 * Parse #-separated tags string into array of trimmed non-empty strings with first letter capitalized.
 * Duplicates (same word in any casing) are collapsed to a single normalized tag.
 */
/** Tags from denormalized array or metadata.rows[id].data.Tags (legacy products). */
export function extractProductTags(product: {
  _id: string;
  tags?: string[];
  metadata?: { rows?: Record<string, { data?: { Tags?: string } }> };
}): string[] {
  if (product.tags?.length) return product.tags;
  const tagsStr = product.metadata?.rows?.[product._id]?.data?.Tags;
  if (typeof tagsStr === 'string') return tagsStringToArray(tagsStr);
  const fallbackStr = product.metadata?.rows?.default?.data?.Tags;
  if (typeof fallbackStr === 'string') return tagsStringToArray(fallbackStr);
  return [];
}

export function tagsStringToArray(input: string | undefined | null): string[] {
  if (input == null || typeof input !== 'string') return [];
  const normalized = input
    .split('#')
    .map((s) => s.trim())
    .filter(Boolean)
    .map(capitalizeFirstLetter);
  return [...new Set(normalized)];
}
